module.exports = __webpack_public_path__ + "static/theia-gravidez-print2-6800a41f855dbd9b1da775f6615fdad1.png";